import React, { useState, useEffect } from "react";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import NeedHelp from '../../components/need-help'

import { getSS } from '../../helpers'

const UpgradeForm: React.FC = (props: any) => {

  // console.log(props);

  interface upgradeOptionsProps {
    selected: string;
    to: string;
    price: string;
  }

  interface SelectedMembershipProps {
    [key: string]: any
  }

  const membership_form = (window as any).KEW.collections.membership_form[0]
  const types = JSON.parse(membership_form.membership_types)

  const [ upgradeOptions, setUpgradeOptions ] = useState<upgradeOptionsProps | undefined>(undefined)
  const [ selectedMembership, setSelectedMembership ] = useState<SelectedMembershipProps | undefined>(undefined)

  let membership = getSS('membership')

  useEffect(() => {
    if (membership) {
      const selected = membership.selected_membership.upgrade_from
      const to = membership.selected_membership.title
      for (let i = 0; i < types.length; i++) {
          if (types[i].title === membership.selected_membership.upgrade_from) {
            let selected_membership = types[i]
            selected_membership.upgrade_from = selected
            setSelectedMembership(selected_membership)
          }
      }
      const price = membership.amount
      setUpgradeOptions({selected, to, price})
    }
    // eslint-disable-next-line
  }, [])

  function getSelectedMembership(type: any) {
    setUpgradeOptions(undefined)
    for (var i = 0; i < types.length; i++) {
        if (types[i].value === type) {
          let selected_membership = types[i];
          selected_membership.upgrade_from = types[i].title;
          setSelectedMembership(selected_membership)
        }
    }
  }

  function showUpgradeNext(selected: any, to: any, price: any) {
    setUpgradeOptions({selected, to, price})
  }

  function setSelectedMembershipModel(selectedMembership: any) {
    props.setFieldValue('payment_type', 'Single')
    props.setFieldValue('payment_method', 'Card/Paypal')
    // update selected membership to chosen upgrade
    for (var i = 0; i < types.length; i++) {
        if (types[i].title === upgradeOptions?.to) {
          let selected_membership_upgrades = selectedMembership.upgrades
          let selected_membership = types[i];
          selected_membership.upgrades = selected_membership_upgrades
          selected_membership.upgrade_from = upgradeOptions?.selected
          props.setFieldValue('amount', upgradeOptions?.price)
          props.setFieldValue('selected_membership', selected_membership)
          props.submitForm()
        }
    }
  }

  return (
    <>
      <div className="row">
        <div className="upgrade-form clearfix box">
          <div className="medium-6 columns">
            <h2>Your current membership</h2>
            <p>Please select your current membership:</p>
            <div className="buttons">
              {
                types.map((type:any, index:any) => {
                  if (type.value !== 'jointfamfriend') {
                    return (
                      <button
                        key={index}
                        type="button"
                        className={`md-raised${selectedMembership?.upgrade_from === type.title ? ' active' : '' }`}
                        onClick={() => getSelectedMembership(type.value)}
                      >
                        <span>{type.title}</span>
                      </button>
                    )
                  } else {
                    return null
                  }
                })
              }
            </div>
            <div className="upgrade_options">
              { selectedMembership?.upgrade_from &&
                <>
                  <h2>Your upgrade</h2>
                  <p>Please choose an upgrade option:</p>
                </>
              }
              { selectedMembership?.upgrades &&
                <div className="radios">
                  <FormControl component="fieldset">
                    <RadioGroup
                      name="upgrade_options"
                      value={upgradeOptions?.to || ''}
                      onChange={props.handleChange}>
                      {
                        selectedMembership.upgrades.map((upgrade: any, i: any) => {
                          return (
                            <React.Fragment key={i}>
                              <FormControlLabel
                                key={i}
                                value={upgrade.upgrade_to}
                                checked={upgradeOptions?.to === upgrade.upgrade_to}
                                control={<Radio color="secondary" />}
                                label={`${upgrade.upgrade_to}: upgrade for £${upgrade.price}`}
                                onClick={() => showUpgradeNext(selectedMembership?.title, upgrade.upgrade_to, upgrade.price)} />
                              <p>{upgrade.description}</p>
                            </React.Fragment>
                          )
                        })
                      }
                    </RadioGroup>
                  </FormControl>
                </div>
              }
            </div>
          </div>
          <div className="medium-6 columns">
            <img src="/assets/default/images/membership-upgrade.jpg" alt="Upgrade your Kew membership"/>
          </div>
          { upgradeOptions &&
            <div>
              <div className="medium-12 columns">
                <div className="divider"></div>
              </div>
              <div className="medium-6 columns">
                <p>You have selected to upgrade from <strong>{upgradeOptions.selected}</strong> membership to <strong>{upgradeOptions.to}</strong> membership at a cost of <strong>£{upgradeOptions.price}</strong></p>
                <button
                  className="btn-cta go"
                  id="upgrade-next"
                  type="button"
                  onClick={(e: any) => {
                    e.preventDefault()
                    setSelectedMembershipModel(selectedMembership)
                }}>Next</button>
              </div>
              <div className="medium-6 columns">
                <NeedHelp />
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default UpgradeForm;




